const variantes = {
  // Relleno dorado con texto oscuro: 7.52:1. La combinación inversa
  // (marfil sobre oro-profundo) queda en 4.42:1 y no se usa a propósito.
  primario:
    'bg-oro text-noche hover:bg-oro-claro focus-visible:bg-oro-claro font-medium',
  secundario:
    'border border-oro-profundo text-oro-claro hover:border-oro hover:text-marfil',
  discreto: 'text-marfil-suave hover:text-oro-claro',
}

// min-h asegura el área táctil de 44px que piden WCAG 2.5.5 y las guías de
// iOS/Android: solo con el padding, `md` se quedaba en ~42px y `sm` en ~28px.
const tamanos = {
  md: 'min-h-11 px-6 py-3 text-sm',
  sm: 'min-h-10 px-4 py-2 text-xs',
}

function Boton({
  variante = 'primario',
  tamano = 'md',
  as: Componente = 'button',
  className = '',
  children,
  ...props
}) {
  const clases = [
    'inline-flex items-center justify-center gap-2 rounded-sm text-center tracking-wide',
    'transition-[color,background-color,border-color,scale] duration-200',
    // Feedback al pulsar. En móvil es el único que queda: index.css desactiva
    // el destello gris nativo, que sobre esta paleta oscura quedaba sucio.
    // El escalado se anula con prefers-reduced-motion.
    'active:scale-[0.98] motion-reduce:active:scale-100',
    'disabled:cursor-not-allowed disabled:opacity-50 disabled:active:scale-100',
    variantes[variante],
    tamanos[tamano],
    className,
  ].join(' ')

  return (
    <Componente
      className={clases}
      {...(Componente === 'button' ? { type: props.type ?? 'button' } : null)}
      {...props}
    >
      {children}
    </Componente>
  )
}

export default Boton
